import BroadcastsHeader from 'component/Broadcasts/BroadcastsHeader'
import BroadcastsTable from 'component/Broadcasts/BroadcastsTable'
import { FC } from 'react'
import { useAppSelector } from 'hooks/reduxHooks'
import { isEqual } from 'lodash'
import BroadcastsStats from 'component/Broadcasts/BroadcastsStats'

const BroadcastsPageLayout: FC = () => {
	const view = useAppSelector(state => state.broadcasts.view, isEqual)

	return (
		<>
			<BroadcastsHeader />
			{view === 'LIST' ? <BroadcastsTable /> : <BroadcastsStats />}
		</>
	)
}

export default BroadcastsPageLayout
